export function setPageTitle(title: string) {
  if (typeof document !== "undefined") {
    document.title = title;
  }
}

export function setMetaDescription(description: string) {
  if (typeof document === "undefined") return;
  const name = "description";
  let tag = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement | null;
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("name", name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", description);
}